import { render, staticRenderFns } from "./deleteAffiliateRule.vue?vue&type=template&id=66697d39"
import script from "./deleteAffiliateRule.vue?vue&type=script&lang=js"
export * from "./deleteAffiliateRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports